import { useCallback } from "react"
import { useRecoilState, useSetRecoilState } from "recoil"
import { useVideoPopup } from "src/components/mediaPanel/floating-container/useVideoPopup"
import {
  chatsSelector,
  previouslyPublishedChat,
  updateChatSelector
} from "src/recoil/atoms/chats"
import { MessageModel, ReplyModel } from "src/recoil/atoms/chats/types"
import { useWatchPartyController } from "./useWatchParty"

const useToggleShowChatAttachment = (messageId: string | null) => {
  const { startWatchParty, stopWatchParty } = useWatchPartyController()
  const { toggleVideoPopup } = useVideoPopup()

  const [previousChat, setPreviousChat] = useRecoilState(
    previouslyPublishedChat
  )
  const finalMessageId = messageId ?? previousChat.id
  if (finalMessageId === undefined || finalMessageId === null)
    throw "finalMessageId shouldn't be null"
  const [chat, setChat] = useRecoilState(chatsSelector(finalMessageId))
  const updateChatById = useSetRecoilState(updateChatSelector)
  const unpublishChat = (previousChat: Partial<MessageModel>) => {
    updateChatById({
      ...previousChat,
      published: false,
      replyChats: previousChat.replyChats?.map(c => ({
        ...c,
        published: false
      }))
    })
  }

  return useCallback(
    (chatOrReply: Partial<MessageModel> | Partial<ReplyModel>) => {
      console.log(chatOrReply)
      if (previousChat?.id) {
        unpublishChat(previousChat)
      }

      if ("replyChats" in chatOrReply) {
        setPreviousChat(chatOrReply)

        // is a chat message
        if (chatOrReply.published) {
          stopWatchParty()
        } else {
          startWatchParty(chatOrReply.attachmentURL)
        }
        toggleVideoPopup(!chatOrReply.published)
        setChat({ published: !chatOrReply?.published })
      } else {
        setPreviousChat(chat)

        // is a reply chat message, work on parent chat item
        const replyChats = chat.replyChats?.map(item => {
          if (item.id === chatOrReply.id) {
            if (item.published) {
              stopWatchParty()
            } else {
              startWatchParty(item.attachmentURL)
            }
            toggleVideoPopup(!item.published)
            return { ...item, published: !item.published }
          }
          return { ...item, published: false }
        })
        setChat({ replyChats })
      }
    },
    [
      previousChat,
      setPreviousChat,
      chat,
      setChat,
      unpublishChat,
      startWatchParty,
      stopWatchParty,
      toggleVideoPopup
    ]
  )
}

export default useToggleShowChatAttachment
